<mat-card
  [ngClass]="{
    noBoxShadow: viewingIndividualUniversity ? true : false
  }"
  class="matCard"
>
  @if (!viewingIndividualUniversity) {
    <mat-card-header class="matCardHeader">
      <mat-card-title class="matCardTitle">
        <h1>Current Bursary Allocation and Usage</h1>
      </mat-card-title>
      @if (!error) {
        <mat-card-subtitle class="matCardSubtitle">
          @if (!isDean) {
            You have
            <span id="remainingAmount">{{
              checkDecimals(remainingAmount) | customCurrency
            }}</span>
            remaining to allocate to bursary students.
          } @else {
            This department has
            <span id="remainingAmount">{{
              checkDecimals(remainingAmount) | customCurrency
            }}</span>
            remaining to allocate to bursary students.
          }
        </mat-card-subtitle>
      }
    </mat-card-header>
  }

  @if (error) {
    <p class="errors">{{ error }}</p>
  }
  @if (!error) {
    <mat-card-content class="matCardContent">
      <mat-divider
        class="progressBarMatDivider"
        [vertical]="true"
        [ngStyle]="{ width: progressBarMatDivider() }"
        [ngClass]="{
          warnRequested: dividerWidth > 1
        }"
      ></mat-divider>
      <section class="progressBarSection">
        <mat-progress-bar
          mode="determinate"
          [value]="requestedApprovedToTotalRatio"
          class="progressBar"
          [ngClass]="{
            progressBar: requestedApprovedToTotalRatio <= 100,
            giveWarning: checkDecimals(requestedApprovedToTotalRatio) > 100
          }"
        >
        </mat-progress-bar>
        <mat-card-subtitle class="barValues">
          <p class="studentAllocation">
            {{ 0 | customCurrency }}
          </p>
          <p class="totalAllocation">
            {{
              (allocationModel.totalAllocation
                ? checkDecimals(allocationModel.totalAllocation)
                : 0
              ) | customCurrency
            }}
          </p>
        </mat-card-subtitle>
      </section>
    </mat-card-content>
  }
  @if ((!error && isExpanded) || viewingIndividualUniversity) {
    <mat-grid-list
      [gridCols]="{ xs: 1, sm: 2, md: 4, lg: 6, xl: 8 }"
      rowHeight="3rem"
      class="matGridList"
    >
      <mat-grid-tile>
        <section class="gridTile">
          <p class="tileAmountDescription gridTileFlex">Total Allocation</p>
          <p class="tileAmount gridTileFlex">
            {{
              (allocationModel.totalAllocation
                ? checkDecimals(allocationModel.totalAllocation)
                : 0
              ) | customCurrency
            }}
          </p>
        </section>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-divider
          [vertical]="true"
          class="matDivider matDividerApproved"
        ></mat-divider>
        <section class="gridTile">
          <p class="tileAmountDescription gridTileFlex">Approved Amount</p>
          <p class="tileAmount gridTileFlex">
            {{ allocationModel.approvedAmount | customCurrency }}
          </p>
        </section>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-divider
          [vertical]="true"
          class="matDivider matDividerRequested"
        ></mat-divider>
        <section class="gridTile">
          <p class="tileAmountDescription gridTileFlex">Requested Amount</p>
          @if (totalRequested > 0) {
            <p class="tileAmount gridTileFlex">
              {{ totalRequested | customCurrency }}
            </p>
          }
          @if (totalRequested === 0 || !totalRequested) {
            <p class="tileAmount gridTileFlex">
              {{ 0 | customCurrency }}
            </p>
          }
        </section>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-divider
          [vertical]="true"
          class="matDivider matDividerRemaining"
        ></mat-divider>
        <section class="gridTile">
          <p class="tileAmountDescription gridTileFlex">Remaining Amount</p>
          <p class="tileAmount gridTileFlex">
            {{ checkDecimals(remainingAmount) | customCurrency }}
          </p>
        </section>
      </mat-grid-tile>
    </mat-grid-list>
  }
  @if (!viewingIndividualUniversity) {
    <mat-card-footer class="matCardFooter">
      <button
        mat-flat-button
        class="viewMoreButton"
        color="primary"
        (click)="toggleIcon()"
      >
        @if (!isExpanded) {
          <mat-icon class="viewMoreButtonIcon">expand_more</mat-icon>
        }
        @if (isExpanded) {
          <mat-icon class="viewMoreButtonIcon">expand_less</mat-icon>
        }
      </button>
    </mat-card-footer>
  }
</mat-card>
